<template>
    <form @submit.prevent="submitForm" enctype="multipart/form-data">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col">
                    <div class="row mb-3">
                        <div class="col">
                            <label class="form-label" for="client_id">{{ $t('input_client')
                            }}<span style="color: red">*</span></label>
                            <div class="d-flex">
                                <Select :loading="isLoadingUsers" v-model="form.client_id" filter
                                    :options="isEditing ? users.filter(u => u._id === form.client_id?._id) : users"
                                    optionLabel="first_name" :placeholder="$t('placeholder.select_seller')" required
                                    class="w-full md:w-56">
                                    <!-- Dropdown option display -->
                                    <template #value="slotProps">
                                        <div v-if="slotProps.value" class="flex items-center">
                                            <img :alt="slotProps.value.last_name" :src=slotProps.value.avatar
                                                class="w-8 h-8 me-2 rounded-full object-cover" style="width: 32px" />
                                            <div>{{ slotProps.value.first_name }} {{
                                                slotProps.value.last_name }}</div>
                                        </div>
                                        <span v-else>
                                            {{ slotProps.placeholder }}
                                        </span>
                                    </template>
                                    <template #option="slotProps">
                                        <div class="text-sm flex items-center text-sm gap-2">
                                            <img :alt="slotProps.option.last_name" :src=slotProps.option.avatar
                                                class="w-8 h-8 rounded-full object-cover" style="width: 32px" />
                                            <div>{{ slotProps.option.first_name }} {{
                                                slotProps.option.last_name }}</div>
                                        </div>
                                    </template>
                                </Select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <h2 class="content-heading border-bottom mb-4 pb-2">{{ $t('receiver') }}</h2>
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12">
                    <div class="row mb-3">
                        <div class="col-12 col-md-4">
                            <label class="form-label" for="receiver_name">{{ $t('input_name')
                            }}<span style="color: red">*</span></label>
                            <input v-model="form.receiver_name" required type="text" class="form-control"
                                id="receiver_name" />
                        </div>
                        <div class="col-12 col-md-4">
                            <label class="form-label" for="clientSimNumber">{{ $t('input_mobile_number')
                            }}<span style="color: red">*</span></label>
                            <PhoneNumbers :initialSimNumbers="form.receiver_sim_number"
                                @update:simNumbers="handleSimNumbersUpdate" />
                        </div>
                        <div class="col-12 col-md-4">
                            <label class="form-label" for="receiver_area_id">
                                {{ $t('input_area') }} <span style="color: red">*</span>
                                <span v-if="plan_title"
                                    class="fs-xs fw-semibold d-inline-block py-1 px-3 mx-2 rounded-pill bg-info-light text-info"
                                    v-text="plan_title"></span>
                            </label>

                            <Select :loading="isLoadingAreas" v-model="form.receiver_area_id" :options="areas" filter
                                optionLabel="city_name_ar" @change="fetchCityPrice"
                                :placeholder="$t('placeholder.select_area')" class="w-full md:w-56"
                                :virtualScrollerOptions="{ itemSize: 36 }">
                                <!-- Dropdown value display -->
                                <template #value="slotProps">
                                    <div v-if="slotProps.value" class="flex items-center">
                                        <div>{{ slotProps.value.governorate.governorate_name_ar }} - {{
                                            slotProps.value.city_name_ar }}</div>
                                    </div>
                                    <span v-else>
                                        {{ slotProps.placeholder }}
                                    </span>
                                </template>
                                <!-- Dropdown option display -->
                                <template #option="slotProps">
                                    <div class="flex items-center">
                                        <div>{{ slotProps.option.governorate.governorate_name_ar }} - {{
                                            slotProps.option.city_name_ar }}</div>
                                    </div>
                                </template>
                            </Select>

                        </div>

                    </div>
                </div>
            </div>

        </div>
        <h2 class="content-heading border-bottom mb-4 pb-2">{{ $t('location') }}
        </h2>
        <div class="container">
            <div class="row">
                <!-- Left side: Search + Coordinates -->
                <div class="col-12 col-md-6 mb-3">
                    <div class="input-group mb-4">
                        <input type="text" class="form-control" id="address-input"
                            :placeholder="$t('placeholder.google_maps_search')" />
                        <button class="btn btn-outline-secondary" type="button" @click="toggleMapType">
                            <i :class="mapTypeIcon"></i>
                        </button>
                    </div>

                    <label class="form-label" for="coordinates">{{ $t('input_coordinates') }}</label>
                    <div class="row mb-4">
                        <div class="col-6">
                            <input type="text" v-model="form.latitude" class="form-control client_inputs"
                                @input="handleCoordinateChange" placeholder="Latitude (e.g. 30.0444)" />
                        </div>
                        <div class="col-6">
                            <input type="text" v-model="form.longitude" class="form-control client_inputs"
                                @input="handleCoordinateChange" placeholder="Longitude (e.g. 31.2357)" />
                        </div>
                    </div>

                    <label class="form-label" for="shipment_address">{{ $t('input_shipment_address') }}</label>
                    <textarea class="form-control" v-model="form.shipment_address" rows="3"
                        :placeholder="$t('placeholder_minimum_10')"></textarea>
                </div>

                <!-- Right side: Map -->
                <div class="col-12 col-md-6 mb-3">
                    <div class="map-wrapper position-relative">
                        <div id="map_test" style="width: 100%; height: 300px;"></div>
                    </div>
                </div>
            </div>
        </div>
        <h2 class="content-heading border-bottom mb-4 pb-2">{{ $t('shipment') }}</h2>
        <div class="row mb-3">
            <div class="col-md-2">
                <label class="form-label">{{ $t('input_height') }}</label>
                <InputGroup>
                    <InputNumber v-model="form.shipment_height" />
                    <InputGroupAddon>CM</InputGroupAddon>
                </InputGroup>
            </div>
            <div class="col-md-2">
                <label class="form-label">{{ $t('input_width') }}</label>
                <InputGroup>
                    <InputNumber v-model="form.shipment_width" />
                    <InputGroupAddon>CM</InputGroupAddon>
                </InputGroup>
            </div>
            <div class="col-md-2">
                <label class="form-label">{{ $t('input_weight') }}</label>
                <InputGroup>
                    <InputNumber v-model="form.shipment_weight" />
                    <InputGroupAddon>KG</InputGroupAddon>
                </InputGroup>
            </div>
            <div class="col-md-6">
                <label class="form-label">{{ $t('input_notes') }}</label>
                <textarea class="form-control" rows="3" v-model="form.shipment_notes"></textarea>
            </div>
        </div>
        <h2 class="content-heading border-bottom mb-4 pb-2">{{ $t('payment') }}
        </h2>
        <div class="row mb-3 mx-2">
            <div class="form-check form-switch mb-2">
                <input class="form-check-input" type="checkbox" id="is_reversed" v-model="form.is_reversed" />
                <label class="form-check-label" for="is_reversed">
                    {{ $t('placeholder_refund_shipment') }}
                </label>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-md-4">
                <label class="form-label">{{ $t('input_owner_price') }}<span style="color:red">*</span></label>
                <InputGroup>
                    <InputGroupAddon>EGP</InputGroupAddon>
                    <InputNumber v-model="form.shipment_price" :disabled="!form.is_reversed" required
                        placeholder="Price" />
                    <InputGroupAddon>.00</InputGroupAddon>
                </InputGroup>
            </div>
            <div class="col-md-4">
                <label class="form-label">{{ $t('input_delivery') }}<span style="color:red">*</span></label>
                <InputGroup>
                    <InputGroupAddon>EGP</InputGroupAddon>
                    <InputNumber v-model="form.delivery_price" disabled required placeholder="Price" />
                    <InputGroupAddon>.00</InputGroupAddon>
                </InputGroup>
            </div>
            <div class="col-md-4">
                <label class="form-label">{{ $t('input_total') }}<span style="color:red">*</span></label>
                <InputGroup>
                    <InputGroupAddon>EGP</InputGroupAddon>
                    <InputNumber v-model="form.grand_total" :disabled="form.is_reversed" required placeholder="Price" />
                    <InputGroupAddon>.00</InputGroupAddon>
                </InputGroup>
            </div>
        </div>
        <h2 class="content-heading border-bottom mb-4 pb-2"></h2>
        <div class="d-flex justify-content-end mb-4">
            <button type="submit" class="btn btn-sm btn-success me-1">
                <i class="fa fa-fw fa-plus me-1"></i> {{ $t('button_submit') }}
            </button>
        </div>
    </form>
</template>
<script>
import PhoneNumbers from "@/components/partner/shipments/components/MultiPhoneNumber.vue"; // Adjust path if needed
import swal from '../../../../utils/swal.js';
export default {
    props: {
        // Pass this prop when editing an existing shipment
        shipment: {
            type: Object,
            default: null
        }
    },
    mounted() {
        this.initMap().then(() => {
            this.mapInitialized = true;
            if (this.shipment?.latitude && this.shipment?.longitude) {
                this.updateMapAndMarker(
                    parseFloat(this.shipment.latitude),
                    parseFloat(this.shipment.longitude)
                );
            }
        });
        this.initAutocomplete();
        if (this.hasCoordinates) {
            this.createMarker(this.parseCoord(this.form.latitude), this.parseCoord(this.form.longitude));
        }
        this.fetchUsers();
        this.fetchAreas();
        console.log('Form:', this.form);
    },
    data() {
        return {
            users: [], // Populate this from API or props
            areas: [], // Populate this from API or props
            plan_title: '',
            form: {
                client_id: null,
                receiver_name: null,
                receiver_area_id: null,
                receiver_sim_number: [],
                latitude: null,
                longitude: null,
                shipment_address: null,
                shipment_height: null,
                shipment_width: null,
                shipment_weight: null,
                shipment_notes: null,
                shipment_price: null,
                delivery_price: null,
                grand_total: null,
                is_reversed: false,
            },
            isEditing: false,
            isLoadingUsers: false,
            isLoadingAreas: false,
            map: null,
            marker: null,
            mapType: 'roadmap',
            baseLayers: {
                roadmap: null,
                satellite: null
            },
            isUpdatingFromMap: false,
            isUpdatingFromInput: false,
            debounceTimer: null
        };
    },
    components: {
        PhoneNumbers,
    },
    computed: {
        mapTypeIcon() {
            return this.mapType === 'roadmap' ? 'fas fa-map' : 'fas fa-satellite';
        },
        hasCoordinates() {
            return this.form.latitude && this.form.longitude;
        },
    },
    watch: {
        shipment: {
            immediate: true,
            async handler(newVal) {
                if (newVal) {
                    while (this.isLoadingUsers || this.isLoadingAreas) {
                        await new Promise(resolve => setTimeout(resolve, 100));
                    }
                    this.setFormData(newVal);
                    this.isEditing = true;
                } else {
                    this.resetForm();
                    this.isEditing = false;
                }
            }
        },
        latitude(newVal) {
            if (!this.isUpdatingFromMap) {
                this.validateAndUpdateMap();
            }
        },
        longitude(newVal) {
            if (!this.isUpdatingFromMap) {
                this.validateAndUpdateMap();
            }
        },
        'form.grand_total': 'updateShipmentPrice',
        'form.delivery_price': 'updateShipmentPrice',
        'form.shipment_price': 'updateGrandTotal',
    },
    methods: {
        setFormData(shipment) {
            const client = this.users.find(u => u._id === shipment.client_id);
            const area = this.areas.find(a => a._id === shipment.receiver_area_id);
            this.form = {
                client_id: client,
                receiver_name: shipment.receiver_name,
                receiver_area_id: area,
                receiver_sim_number: shipment.receiver_sim_number || [],
                latitude: shipment.latitude,
                longitude: shipment.longitude,
                shipment_address: shipment.receiver_address,
                shipment_height: shipment.height,
                shipment_width: shipment.width,
                shipment_weight: shipment.weight,
                shipment_notes: shipment.notes,
                shipment_price: shipment.shipment_price,
                delivery_price: shipment.delivery_price,
                grand_total: shipment.grand_total,
                is_cod: shipment.is_cod || false,
                is_reversed: shipment.is_reversed || false,
                is_price_includes_delivery: shipment.is_price_includes_delivery || false
            };

            if (shipment.latitude && shipment.longitude) {
                this.updateMapAndMarker(shipment.latitude, shipment.longitude);
            }

            console.log('Form data set:', this.form);
        },

        submitForm() {
            if (!this.validateForm()) return;

            const currentData = this.getCurrentFormData();

            if (this.shipment?._id && !this.hasFormChanged(currentData)) {
                Swal.fire({ icon: 'info', title: 'No changes detected', timer: 2000 });
                return;
            }

            this.isLoading = true;

            axios.post('/shipments/save', this.preparePayload(), {
                headers: {
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                    'Content-Type': 'application/json'
                }
            })
                .then(response => this.handleSuccess(response))
                .catch(error => this.handleError(error))
                .finally(() => this.isLoading = false);
        },
        getCurrentFormData() {
            return {
                client_id: this.form.client_id?._id,
                receiver_name: this.form.receiver_name,
                receiver_area_id: this.form.receiver_area_id?._id,
                receiver_sim_number: this.form.receiver_sim_number.filter(n => n.trim()),
                coordinates: this.form.coordinates,
                latitude: this.form.latitude,
                longitude: this.form.longitude,
                shipment_address: this.form.shipment_address,
                shipment_height: this.form.shipment_height,
                shipment_width: this.form.shipment_width,
                shipment_weight: this.form.shipment_weight,
                shipment_notes: this.form.shipment_notes,
                shipment_price: this.form.shipment_price,
                delivery_price: this.form.delivery_price,
                grand_total: this.form.grand_total,
                is_reversed: this.form.is_reversed,
                is_price_includes_delivery: this.form.is_price_includes_delivery
            };
        },
        preparePayload() {
            return {
                _id: this.shipment?._id || null,
                client_id_input: this.form.client_id?._id,
                receiver_name_input: this.form.receiver_name,
                receiver_area_input: this.form.receiver_area_id?._id,
                receiver_sim_number: this.form.receiver_sim_number.filter(n => n.trim()),
                latitude: this.form.latitude,
                longitude: this.form.longitude,
                receiver_address_input: this.form.shipment_address,
                shipment_height_input: this.form.shipment_height,
                shipment_width_input: this.form.shipment_width,
                shipment_weight_input: this.form.shipment_weight,
                shipment_notes_input: this.form.shipment_notes,
                shipment_price_input: this.form.shipment_price,
                delivery_price_input: this.form.delivery_price,
                grand_total_input: this.form.grand_total,
                is_reversed: this.form.is_reversed,
                is_price_includes_delivery: this.form.is_price_includes_delivery
            };
        },
        handleSuccess(response) {
            if (response.data.success) {
                Swal.fire({
                    icon: 'success',
                    title: this.isEditing ? 'Updated!' : 'Created!',
                    timer: 2000
                });
                this.$emit('shipment-saved', response.data.data);
                if (!this.isEditing) this.resetForm();
            } else {
                this.showError(response.data.message || 'Operation failed');
            }
        },
        handleError(error) {
            if (error.response?.status === 422) {
                this.showValidationErrors(error.response.data.errors);
            } else {
                this.showError(error.response?.data.message || 'Network error');
            }
        },
        // Helper method to detect changes
        hasFormChanged(currentData) {
            if (!this.shipment?._id) return true; // Always submit new shipments

            // Compare each field with original shipment data
            return (
                currentData.client_id !== this.shipment.client_id ||
                currentData.receiver_name !== this.shipment.receiver_name ||
                !this.arraysEqual(currentData.receiver_sim_number, this.shipment.receiver_sim_number) ||
                currentData.receiver_area_id !== this.shipment.receiver_area_id ||
                currentData.latitude !== this.shipment.latitude ||
                currentData.longitude != this.shipment.longitude ||
                currentData.shipment_address !== this.shipment.receiver_address ||
                currentData.shipment_height !== this.shipment.height ||
                currentData.shipment_width !== this.shipment.width ||
                currentData.shipment_weight !== this.shipment.weight ||
                currentData.shipment_notes !== this.shipment.notes ||
                currentData.shipment_price !== this.shipment.shipment_price ||
                currentData.delivery_price !== this.shipment.delivery_price ||
                currentData.grand_total !== this.shipment.grand_total ||
                currentData.is_cod !== this.shipment.is_cod ||
                currentData.is_price_includes_delivery !== this.shipment.is_price_includes_delivery ||
                currentData.is_reversed != this.shipment.is_reversed
            );
        },

        // Helper to compare arrays (for phone numbers)
        arraysEqual(a, b) {
            if (a === b) return true;
            if (a == null || b == null) return false;
            if (a.length !== b.length) return true; // Consider different lengths as changed

            // Sort and compare each element
            const sortedA = [...a].sort();
            const sortedB = [...b].sort();

            return sortedA.every((val, index) => val === sortedB[index]);
        },
        // Helper methods
        showValidationErrors(errors) {
    // Solution 2: Properly flatten Laravel-style error object
    const errorMessages = Object.values(errors)
        .flat() // Flatten nested arrays
        .map(msg => typeof msg === 'string' ? msg : String(msg));

    Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        html: errorMessages.join('<br>') || 'Unknown error occurred',
    });
},

        handleApiError(responseData) {
            if (responseData.errors) {
                this.showValidationErrors(responseData.errors);
            } else {
                this.showError(responseData.message || 'Operation failed');
            }
        },

        validateForm() {
            // Your existing validation logic
            if (!this.form.client_id) {
                this.showError('Please select a seller');
                return false;
            }
            if (!this.form.receiver_name) {
                this.showError('Receiver name is required');
                return false;
            }
            if (!this.form.receiver_sim_number || this.form.receiver_sim_number.length === 0) {
                this.showError('At least one phone number is required');
                return false;
            }
            /* if (!this.form.receiver_area_id) {
                this.showError('Receiver area is required');
                return false;
            } */
            return true;
        },

        resetForm() {
            this.form = {
                client_id: null,
                receiver_name: null,
                receiver_area_id: null,
                receiver_sim_number: [],
                shipment_address: null,
                shipment_height: null,
                shipment_width: null,
                shipment_weight: null,
                shipment_notes: null,
                shipment_price: null,
                delivery_price: null,
                grand_total: null,
                coordinates: null,
                is_reversed: false
            };
            this.plan_title = '';
            this.isEditing = false;

            // Reset map to default view
            if (this.map) {
                this.map.setView([30.0444, 31.2357], 10);
                if (this.marker) {
                    this.marker.remove();
                    this.marker = null; // Clear the marker reference
                }
            }
        },
        fetchAreas() {
            this.isLoadingAreas = true;
            axios.get('/get-all-areas')
                .then((response) => {
                    this.areas = response.data;
                })
                .catch((error) => {
                    console.error('Error fetching areas:', error);
                }).finally(() => {
                    this.isLoadingAreas = false;
                });
        },
        fetchUsers() {
            this.isLoadingUsers = true;
            $.ajax({
                url: '/get-all-clients',  // Replace with your endpoint
                method: 'GET',
                success: (data) => {
                    this.users = data;
                    this.isLoadingUsers = false;
                },
                error: (xhr, status, error) => {
                    console.error('Error fetching users:', error);
                    this.isLoadingUsers = false;
                }
            });
        },
        fetchCityPrice() {
            console.log('Selected Client:', this.form.client_id);
            console.log('Selected Area:', this.form.receiver_area_id);
            if (!this.form.client_id._id || !this.form.receiver_area_id._id) return;

            axios.post('/price-plans/fetch-city-price', {
                client_id: this.form.client_id._id,
                city_id: this.form.receiver_area_id._id,
            })
                .then((response) => {
                    this.form.delivery_price = response.data.price;
                    this.plan_title = response.data.plan_title;
                    if (response.data.price == 0) {
                        this.form.shipment_price = 0;
                        swal.info(this.$t('message_free_shipment'));

                    } else {
                        Swal.fire({
                            icon: 'success',
                            title: 'Success',
                            text: 'City price fetched successfully.',
                            showConfirmButton: false,
                            timer: 1500
                        });
                        this.form.shipment_price = response.data.price;
                    }
                })
                .catch((error) => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: error,
                    });
                    console.error('Error fetching city price:', error);
                });
        },
        handleSimNumbersUpdate(updatedSimNumbers) {
            console.log('Updated SIM Numbers:', updatedSimNumbers);
            this.form.receiver_sim_number = updatedSimNumbers;
        },
        updateShipmentPrice() {
            // Ensure that grand_total is recalculated when shipment_price is updated
            this.form.shipment_price = parseFloat(this.form.grand_total) - parseFloat(this.form.delivery_price);
        },
        // Update the grand total when delivery price changes
        updateGrandTotal() {
            // Ensure that grand_total is recalculated when delivery_price is updated
            this.form.grand_total = parseFloat(this.form.shipment_price) + parseFloat(this.form.delivery_price);
        },
        showError(message) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: message,
            });
        },
        async initMap() {
            return new Promise((resolve) => {
                // Fix Leaflet icon paths
                delete L.Icon.Default.prototype._getIconUrl;
                L.Icon.Default.mergeOptions({
                    iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
                    iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
                    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
                });

                const defaultLat = 30.0444;
                const defaultLng = 31.2357;
                const lat = this.parseCoord(this.form.latitude) || defaultLat;
                const lng = this.parseCoord(this.form.longitude) || defaultLng;

                this.map = L.map('map_test').setView([lat, lng], 15);

                // Configure base layers
                this.baseLayers.roadmap = L.tileLayer(
                    'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                    { attribution: '© OpenStreetMap contributors' }
                ).addTo(this.map);

                this.baseLayers.satellite = L.tileLayer(
                    'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
                    { attribution: 'Tiles © Esri' }
                );

                // Map event handlers
                this.map.on('click', this.handleMapClick);

                resolve();
            });
        },

        createMarker(lat, lng) {
            if (!this.map) return;

            // Remove existing marker if any
            if (this.marker) {
                this.map.removeLayer(this.marker);
            }

            this.marker = L.marker([lat, lng], {
                draggable: true,
                autoPan: true
            })
                .on('dragend', this.handleMarkerDrag)
                .addTo(this.map);

            this.map.setView([lat, lng], this.map.getZoom());
        },

        handleCoordinateChange() {
            clearTimeout(this.debounceTimer);
            this.debounceTimer = setTimeout(() => {
                this.validateAndUpdateFromCoordinates();
            }, 800);
        },

        validateAndUpdateFromCoordinates() {
            if (this.isUpdatingFromMap) return;

            const lat = this.parseCoord(this.form.latitude);
            const lng = this.parseCoord(this.form.longitude);

            if (!this.isValidCoordinate(lat) || !this.isValidCoordinate(lng)) {
                if (this.marker) {
                    this.map.removeLayer(this.marker);
                    this.marker = null;
                }
                this.map.setView([30.0444, 31.2357], 10); // Default to Cairo
                return;
            }

            this.isUpdatingFromInput = true;
            this.updateMapAndMarker(lat, lng);
            setTimeout(() => this.isUpdatingFromInput = false, 50);
        },

        updateFromMap(lat, lng) {
            if (!this.isValidCoordinate(lat) || !this.isValidCoordinate(lng)) {
                console.error('Invalid coordinates:', lat, lng);
                return;
            }

            if (!this.isInEgypt(lat, lng)) {
                this.showError('Coordinates must be within Egypt');
                return;
            }

            this.isUpdatingFromMap = true;

            // Update form data
            this.form.latitude = lat;
            this.form.longitude = lng;
            this.form.shipment_address = ''; // Will be updated by reverse geocoding

            // Update map view
            this.updateMapView(lat, lng);

            // Update or create marker
            if (!this.marker) {
                this.createMarker(lat, lng);
            } else {
                this.marker.setLatLng([lat, lng]);
            }

            // Reverse geocode to get address
            this.reverseGeocode(lat, lng);

            setTimeout(() => {
                this.isUpdatingFromMap = false;
            }, 50);
        },

        isValidCoordinate(coord) {
            return coord !== null && !isNaN(coord) && isFinite(coord);
        },

        handleMarkerDrag(e) {
            const { lat, lng } = e.target.getLatLng();
            this.updateCoordinates(lat, lng);
            this.map.panTo(e.target.getLatLng());  // Optional: Keep map centered on marker
        },

        handleMapClick(e) {
            const { lat, lng } = e.latlng;
            this.updateCoordinates(lat, lng);
            if (!this.marker) {
                this.createMarker(lat, lng);
            } else {
                this.marker.setLatLng([lat, lng]);
            }
        },

        updateCoordinates(lat, lng) {
            if (!this.isInEgypt(lat, lng)) return;

            this.isUpdatingFromMap = true;
            this.form.latitude = parseFloat(lat.toFixed(6));
            this.form.longitude = parseFloat(lng.toFixed(6));
            this.updateMapAndMarker(lat, lng);
            setTimeout(() => this.isUpdatingFromMap = false, 50);
        },

        updateMapAndMarker(lat, lng) {
            if (!this.map) return;

            if (!this.isInEgypt(lat, lng)) {
                this.showError('Coordinates must be within Egypt');
                return;
            }

            if (!this.marker) {
                this.createMarker(lat, lng);
            } else {
                this.marker.setLatLng([lat, lng]);
            }

            this.map.setView([lat, lng], this.map.getZoom());
        },

        validateAndUpdateMap() {
            if (this.isUpdatingFromMap) return;

            const lat = this.parseCoord(this.form.latitude);
            const lng = this.parseCoord(this.form.longitude);

            if (!lat || !lng) {
                if (this.marker) {
                    this.map.removeLayer(this.marker);
                    this.marker = null;
                }
                this.map.setView([30.0444, 31.2357], 10); // Default to Cairo
                return;
            }

            this.isUpdatingFromInput = true;
            this.updateMapAndMarker(lat, lng);
            setTimeout(() => this.isUpdatingFromInput = false, 50);
        },

        toggleMapType() {
            this.mapType = this.mapType === 'roadmap' ? 'satellite' : 'roadmap';
            this.map.eachLayer(layer => {
                if (layer !== this.marker) this.map.removeLayer(layer);
            });
            this.baseLayers[this.mapType].addTo(this.map);
        },

        initAutocomplete() {
            if (window.google?.maps) return this.setupAutocomplete();
            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${window.googleMapsKey}&libraries=places`;
            script.onload = () => this.setupAutocomplete();
            script.onerror = console.error;
            document.head.appendChild(script);
        },



        setupAutocomplete() {
            const input = document.getElementById('address-input');
            if (!input) return;

            const autocomplete = new google.maps.places.Autocomplete(input, {
                componentRestrictions: { country: 'eg' },
                fields: ['geometry', 'formatted_address']
            });

            // Timer for debouncing coordinate detection
            let coordinateCheckTimer;

            input.addEventListener('input', (e) => {
                clearTimeout(coordinateCheckTimer);
                coordinateCheckTimer = setTimeout(() => {
                    this.handlePotentialCoordinates(input.value);
                }, 800); // 0.8 second delay after typing stops
            });

            autocomplete.addListener('place_changed', () => {
                const place = autocomplete.getPlace();
                if (!place?.geometry) return;

                const lat = place.geometry.location.lat();
                const lng = place.geometry.location.lng();
                this.updateCoordinates(lat, lng);
            });
        },

        handlePotentialCoordinates(input) {
            if (!input || typeof input !== 'string') return;

            // 1. Normalize the input first
            const normalized = input
                .replace(/[°º˚]|deg(rees?)?/gi, '°')
                .replace(/[′'‘’`]|min(utes?)?/gi, "'")
                .replace(/[″"“”]|sec(onds?)?/gi, '"')
                .replace(/\s+/g, ' ')
                .trim();

            // 2. Try DMS format (now more flexible)
            const dmsPattern = /^([NS]?\s*)?(\d+)°\s*(\d+)['′]\s*([\d.]+)[″"]\s*([NS]?)\s*,?\s*([EW]?\s*)?(\d+)°\s*(\d+)['′]\s*([\d.]+)[″"]\s*([EW]?)$/i;

            const dmsMatch = normalized.match(dmsPattern);
            if (dmsMatch) {
                const latDeg = parseFloat(dmsMatch[2]);
                const latMin = parseFloat(dmsMatch[3]);
                const latSec = parseFloat(dmsMatch[4]);
                const latDir = (dmsMatch[1] || dmsMatch[5] || 'N').toUpperCase();

                const lngDeg = parseFloat(dmsMatch[7]);
                const lngMin = parseFloat(dmsMatch[8]);
                const lngSec = parseFloat(dmsMatch[9]);
                const lngDir = (dmsMatch[6] || dmsMatch[10] || 'E').toUpperCase();

                const lat = (latDeg + latMin / 60 + latSec / 3600) * (latDir === 'S' ? -1 : 1);
                const lng = (lngDeg + lngMin / 60 + lngSec / 3600) * (lngDir === 'W' ? -1 : 1);

                if (!isNaN(lat) && !isNaN(lng)) {
                    this.updateCoordinates(lat, lng);
                    this.reverseGeocode(lat, lng);
                    return;
                }
            }

            // 3. Try decimal format (more robust)
            const decimalPattern = /^(-?\d+\.?\d*)\s*[,;]\s*(-?\d+\.?\d*)$/;
            const decimalMatch = normalized.match(decimalPattern);
            if (decimalMatch) {
                const lat = parseFloat(decimalMatch[1]);
                const lng = parseFloat(decimalMatch[2]);

                if (!isNaN(lat) && !isNaN(lng)) {
                    this.updateCoordinates(lat, lng);
                    return;
                }
            }

            // 4. Try space-separated DMS (e.g., "29 59 38.8 N 31 23 42.7 E")
            const spaceDmsPattern = /^(\d+)\s+(\d+)\s+([\d.]+)\s*([NS]?)\s*,?\s*(\d+)\s+(\d+)\s+([\d.]+)\s*([EW]?)$/i;
            const spaceMatch = normalized.match(spaceDmsPattern);
            if (spaceMatch) {
                const lat = this.dmsToDecimal(`${spaceMatch[1]}°${spaceMatch[2]}'${spaceMatch[3]}"${spaceMatch[4] || 'N'}`);
                const lng = this.dmsToDecimal(`${spaceMatch[5]}°${spaceMatch[6]}'${spaceMatch[7]}"${spaceMatch[8] || 'E'}`);

                if (lat && lng) {
                    this.updateCoordinates(lat, lng);
                    return;
                }
            }
        },
        // Convert DMS to Decimal Degrees
        dmsToDecimal(dms) {
            // 1. Normalize all possible symbol variations
            const normalized = String(dms)
                .replace(/[°º˚ᵒ]|deg(rees?)?/gi, '°')  // Normalize degree symbols
                .replace(/[′'‘‵`]|min(utes?)?/gi, "'") // Normalize minute symbols
                .replace(/[″"“”〃]|sec(onds?)?/gi, '"') // Normalize second symbols
                .replace(/,/g, '.')                    // Handle European decimals
                .replace(/\s+/g, ' ')                  // Standardize spaces
                .trim();

            // 2. Main regex pattern (covers all cases)
            const pattern = /^([NS]?\s*)?(-?\d{1,3})[°\s]?\s*(-?\d{1,2})['\s]?\s*(-?[\d.]+)["\s]?\s*([NS]?)\s*$/i;
            const match = normalized.match(pattern);

            if (!match) return null;

            // 3. Extract components (with negative number support)
            const degrees = parseFloat(match[2]);
            const minutes = parseFloat(match[3]);
            const seconds = parseFloat(match[4]);
            const direction = (match[1] || match[5] || 'N').toUpperCase();

            // 4. Validate ranges
            if (Math.abs(degrees) > 180 || Math.abs(minutes) >= 60 || seconds >= 60) {
                return null;
            }

            // 5. Calculate decimal
            let decimal = degrees + (minutes / 60) + (seconds / 3600);
            if (direction === 'S' || direction === 'W') {
                decimal = -Math.abs(decimal); // Ensure proper sign
            }

            // 6. Round to 6 decimal places (standard GPS precision)
            return parseFloat(decimal.toFixed(6));
        },
        parseCoord(value) {
            const num = parseFloat(value);
            return isNaN(num) ? null : num;
        },

        isInEgypt(lat, lng) {
            return lat >= 22 && lat <= 31.7 && lng >= 24.7 && lng <= 37;
        },

        showError(message) {
            console.error(message);
            // Add your error display logic here
        }

    },
};
</script>
<style>
.map-wrapper {
    position: relative;
    height: 300px;
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid #dee2e6;
}

.map-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.leaflet-marker-icon {
    filter: hue-rotate(120deg) drop-shadow(0 0 4px rgba(0, 0, 0, 0.5));
    transition: transform 0.2s ease;
}

.leaflet-marker-icon:hover {
    transform: scale(1.2);
}
</style>